import axios from 'axios'
import { FILE_HOST } from 'utils/helpers/apiHelper'
import { FixMeLater } from 'types'
import { AxiosProgressEvent } from 'axios'


let controller = new AbortController()



const axiosApi = {
  setHeader: async (accessToken: string) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
  },
  request: async (method: string, path: string, params?: FixMeLater, config?: FixMeLater) => {
    return await axios({
      method,
      url: `${FILE_HOST}${path}`,
      data: params,
      ...config,
      headers: {
        ...axios.defaults.headers.common,
        ...config?.headers,
      },
    })
  },
  uploadFile: async (
    path: string,
    files: File[],
    appendName: string,
    formDataParams?: FixMeLater,
    onUploadProgress?: (event: AxiosProgressEvent) => void,
    accessToken?: string,
  ) => {
    controller = new AbortController()
    const formData = new FormData()
    files.forEach((file) => {
      formData.append(appendName, file)
    })
    if (formDataParams) {
      Object.entries(formDataParams).forEach(([key, value]) => {
        formData.append(key, JSON.stringify(value))
      })
    }
    return await axios({
      method: 'POST',
      url: `${FILE_HOST}/${path}`,
      data: formData,
      onUploadProgress,
      signal: controller.signal,
      timeout: 300000, // 5 dakika timeout (büyük dosyalar için)
      headers: {
        ...axios.defaults.headers.common,
        ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
      },
    })
  },
  clearToken: () => {
    axios.defaults.headers.common['Authorization'] = ''
  },
  cancelUploadFile: () => {
    controller.abort()
  },
  downloadFileWithUrl: async (url: string) => {
    try {
      const response = await fetch(url, {
        method: 'GET',
        credentials: 'include'
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();
      return URL.createObjectURL(blob);
    } catch (error) {
      console.error('File download failed:', error);
      throw error;
    }
  },
    getPresignedUrl: async (filePath: string, accessToken?: string): Promise<string> => {
    try {
   
      const response = await axios({
        method: 'GET',
        url: `${FILE_HOST}${filePath}`,
        headers: {
          ...axios.defaults.headers.common,
          ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
        },
      });
      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const { presignedUrl } = response.data;
      return presignedUrl;
    } catch (error) {
      console.error('Presigned URL fetch failed:', error);
      throw error;
    }
  },
  get: (path: string) => axiosApi.request('GET', path),
  post: (path: string, params: FixMeLater) => axiosApi.request('POST', path, params),
  put: (path: string, params?: FixMeLater) => axiosApi.request('PUT', path, params),
}

export default axiosApi
